/**
 * O resultado de "Testar conexão" — o mesmo quadro no formulário (antes de salvar) e no
 * cartão da conta (depois).
 *
 * Diz QUANDO testou: "funcionando" sem hora é afirmação que envelhece calada. E mostra o
 * status da conta NA META separado do resultado do token: o token pode estar perfeito e a
 * conta, desativada por pagamento — e aí "conexão ok" com zero gasto confundiria qualquer um.
 */
import { Badge, FormAlert } from '@mgdlead/ui';

import { statusDaContaMeta } from '../../../features/ads/ads-ui';
import type { AdsConnectionTest } from '../../../lib/api';

function hora(iso: string): string {
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function ResultadoDoTeste({ teste }: { teste: AdsConnectionTest }) {
  if (!teste.ok) {
    return (
      <FormAlert
        tone={teste.outcome === 'UNAVAILABLE' ? 'warning' : 'danger'}
        title={
          teste.outcome === 'UNAVAILABLE'
            ? `Não deu para testar agora (${hora(teste.checkedAt)})`
            : `A conexão não funciona (testado às ${hora(teste.checkedAt)})`
        }
      >
        {teste.message}
      </FormAlert>
    );
  }

  const conta = teste.account;
  const status = statusDaContaMeta(conta?.status ?? null);
  return (
    <FormAlert tone="success" title={`Conexão funcionando — testado às ${hora(teste.checkedAt)}`}>
      <span className="block">{teste.message}</span>
      <span className="mt-2 flex flex-wrap items-center gap-1">
        {conta?.name ? <Badge tone="outline">{conta.name}</Badge> : null}
        <Badge tone={status.tone} dot>
          {status.label}
        </Badge>
        {conta?.currency ? (
          <Badge tone="outline" numeric>
            {conta.currency}
          </Badge>
        ) : null}
        <Badge tone="success">ads_read</Badge>
      </span>
    </FormAlert>
  );
}
